import { makeAutoObservable } from "mobx";
import JSONData from "../data/hotels.json";

class SearchModel {
  errorPlaces = false;
  errorHotels = false;
  errorDuration = false;
  firstPlace = null;
  features = null;
  query = null;
  searchQuery = {
    value: "",
    type: "place",
    bookingId: "",
  };
  places = [];
  hotels = [];
  searchResultsHotels = [];
  focusedInput = null;
  startDate = null;
  endDate = null;
  couponCode = "";
  search = null;
  isLoading = true;
  hotelList = JSONData;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}

const SearchStore = new SearchModel();
export default SearchStore;
